import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { f as j } from "./index-LyFokDcn.mjs";
import { P as k } from "./progress-bar-RdhhxBEI.mjs";
import { f as x, a as y } from "./text-B5Opw2za.mjs";
import { m as P } from "./tss-DN0acMKN.mjs";
import { M as g, d as c } from "./constants-CnFYFetN.mjs";
import { u as R } from "./use-screen-sizes-hx44ztp3.mjs";
var u = /* @__PURE__ */ ((e) => (e.left = "left", e.right = "right", e))(u || {}), d = /* @__PURE__ */ ((e) => (e.task = "task", e.step = "step", e.percentage = "percentage", e))(d || {});
const N = P()(({ constructs: e, palette: r, spacing: s, mode: n }, { current: o, total: t }) => j.ifFeature(
  "encore",
  {
    root: {
      alignItems: "center",
      display: "flex",
      outline: n === g.Dye ? `1px solid ${c.main}` : void 0
    },
    note: {
      color: e.text.neutral.medium,
      fontSize: x("small"),
      lineHeight: y("small")
    },
    marginLeft: {
      marginRight: s(1.5)
    },
    marginRight: {
      marginLeft: s(1.5)
    },
    innerProgress: {},
    outerProgress: {}
  },
  {
    root: {
      alignItems: "center",
      display: "flex",
      outline: n === g.Dye ? `1px solid ${c.main}` : void 0
    },
    note: {
      color: r.gray[700],
      fontSize: x("small"),
      lineHeight: y("small")
    },
    marginLeft: {
      marginRight: s(1)
    },
    marginRight: {
      marginLeft: s(1)
    },
    outerProgress: {
      backgroundColor: n === g.Dye ? c.lightest : r.gray[200],
      borderRadius: "6px",
      height: "12px",
      overflow: "hidden",
      width: "412px"
    },
    innerProgress: {
      background: n === g.Dye ? c.main : `linear-gradient(to right, ${r.primary.lightest}, ${r.primary.lighter})`,
      height: "100%",
      minWidth: "6px",
      width: o >= t ? "100%" : `${100 * o / t}%`
    }
  }
)), C = (e) => {
  const { current: r, height: s, note: n = "", placement: o = "right", total: t, type: f = "task", width: p = "412px" } = e, { classes: a } = N(e), w = window.jQuery ? $.__("Step") : "Step", S = window.jQuery ? $.__("of") : "of", h = Math.round(r / t * 100), b = window.jQuery ? $.__("on step %1 of %2", r, t) : `on step ${r} of ${t}`, v = window.jQuery ? $.__("%1 of %2", r, t) : `${r} of ${t}`, L = window.jQuery ? $.__("%1%%", h) : `${h}%`;
  let l, m = "";
  const { isMediumScreen: _ } = R(!0);
  return f === d.task && (l = /* @__PURE__ */ i.jsxs("span", { className: a.note, children: [
    r || "0",
    "/",
    t,
    " ",
    n
  ] }), m = v), f === d.step && (l = /* @__PURE__ */ i.jsx("span", { "aria-hidden": !0, className: a.note, children: `${w} ${r || "0"} ${S} ${t}` }), m = b), f === d.percentage && (l = /* @__PURE__ */ i.jsx("span", { "aria-hidden": !0, className: a.note, children: `${h}%` }), m = L), /* @__PURE__ */ i.jsxs("div", { "aria-label": m, className: a.root, "data-fabric-component": "TaskProgressBar", role: "status", children: [
    o === u.left && /* @__PURE__ */ i.jsx("div", { className: a.marginLeft, children: l }),
    j.ifFeature(
      "encore",
      /* @__PURE__ */ i.jsx(k, { current: r, height: s, total: t, width: _ ? `min(${p}, 100%)` : p }),
      /* @__PURE__ */ i.jsx("div", { className: a.outerProgress, children: /* @__PURE__ */ i.jsx("div", { className: a.innerProgress }) })
    ),
    o === u.right && /* @__PURE__ */ i.jsx("div", { className: a.marginRight, children: l })
  ] });
};
export {
  C as T
};
//# sourceMappingURL=task-progress-bar-BXWKhTG1.mjs.map
